module.exports = __webpack_public_path__ + "img/recruit-icon-2.0d0417d4.png";